export default {
  en: {
    "billManagement.label.BillCycle": "Bill Cycle",
    "billManagement.label.billing": "Billing",
    "billManagement.label.trialBilling": "Trial Billing",
    "billManagement.label.start": "Start",
    "billManagement.label.all": "All",
    "billManagement.label.upload": "Upload",
    "billManagement.label.BillingManagement": "Billing Management",
    "billManagement.label.CreateBillingCycle": "Create Billing Cycle",
    "billManagement.label.BillingDay": "Billing Day",
    "billManagement.label.BillingCycle": "Billing Cycle",
    "billManagement.label.BDOM": "BDOM",
    "billManagement.label.LastBillingDate": "Last Billing Date",
    "billManagement.label.NextBillingDate": "Next Billing Date",
    "billManagement.label.InterfaceDay": "Interface Day",
    "billManagement.label.CurrentCycleDate": "Current Cycle Date",
    "billManagement.label.NoOfProfileBills": "No. Of Profile Bills",
    "billManagement.label.Status": "Status",
    "billManagement.label.History": "History",
    "billManagement.label.Action": "Actions",
    "billManagement.label.BillHistory": "Bill History",
    "billManagement.label.TrialBillHistory": "Trial Bill History",
    "billManagement.label.ExecutionDate": "Execution Date",
    "billManagement.label.ExpectedNoOfCustomer": "Expected No. Of Customer",
    "billManagement.label.ActualBilledCustomer": "Actual Billed Customer",
    "billManagement.label.TotalBillingAmount": "Total Billing Amount",
    "billManagement.label.DownloadReport": "Download Report",
    "billManagement.label.DownloadBillDetail": "Download Bill Detail",
    "billManagement.label.BillingCycleName": "Billing Cycle Name",
    "billManagement.label.BillingFrequency": "Billing Frequency",
    "billManagement.label.BillingDayOfMonth": "Billing Day Of Month",
    "billManagement.label.Cancel": "Cancel",
    "billManagement.label.Confirm": "Confirm",

    "billManagement.label.BillingCycleName": "Billing Cycle Name",
    "billManagement.label.BillFrequency": "Billing Frequency",
    "billManagement.label.ChargeJobRunId": "Charge Job Run Id",
  },

  fr: {
    "billManagement.label.BillCycle": "Cycle de facturation",
    "billManagement.label.billing": "Facturation",
    "billManagement.label.trialBilling": "Facturation d'essai",
    "billManagement.label.start": "Démarrer",
    "billManagement.label.all": "Tout",
    "billManagement.label.upload": "Téléverser",
    "billManagement.label.BillingManagement": "Gestion de facturation",
    "billManagement.label.CreateBillingCycle": "Générer la facturation",
    "billManagement.label.BillingDay": "Jour de facturation",
    "billManagement.label.BillingCycle": "Cycle de facturation",
    "billManagement.label.BDOM": "BDOM",
    "billManagement.label.LastBillingDate": "Dernier jour de facturation",
    "billManagement.label.NextBillingDate": "Prochain jour de facturation",
    "billManagement.label.InterfaceDay": "Jour d'interface",
    "billManagement.label.CurrentCycleDate": "Jour actuel du cycle",
    "billManagement.label.NoOfProfileBills": "Nombre de factures",
    "billManagement.label.Status": "Statut",
    "billManagement.label.History": "Historique",
    "billManagement.label.Action": "Action",
    "billManagement.label.BillHistory": "Historique de facturation",
    "billManagement.label.TrialBillHistory": "Historique des factures d'essai",
    "billManagement.label.ExecutionDate": "Date d'exécution",
    "billManagement.label.ExpectedNoOfCustomer": "Nombre attendu de clients",
    "billManagement.label.ActualBilledCustomer":
      "Nombre réel de clients facturés",
    "billManagement.label.TotalBillingAmount":
      "Montant total de la facturation",
    "billManagement.label.DownloadReport": "Télécharger le rapport",
    "billManagement.label.DownloadBillDetail":
      "Télécharger le détail de la facture",
    "billManagement.label.BillCycleName": "Nom du cycle de facturation",
    "billManagement.label.BillFrequency": "Fréquence de facturation",
    "billManagement.label.BillingDayOfMonth": "Jour de facturation du mois",
    "billManagement.label.Cancel": "Annuler",
    "billManagement.label.Confirm": "Confirmer",

    "billManagement.label.BillingCycleName": "Nom du cycle de facturation",
  "billManagement.label.BillingFrequency": "Fréquence de facturation",
    "billManagement.label.ChargeJobRunId": "ID d'exécution de la tâche de facturation",
  },

  es: {
    "billManagement.label.BillCycle": "Ciclo de facturación",
    "billManagement.label.billing": "Facturación",
    "billManagement.label.trialBilling": "Facturación de prueba",
    "billManagement.label.start": "Iniciar",
    "billManagement.label.all": "Todo",
    "billManagement.label.upload": "Subir",
    "billManagement.label.BillingManagement": "Gestión de facturación",
    "billManagement.label.CreateBillingCycle": "Generar facturación",
    "billManagement.label.BillingDay": "Día de facturación",
    "billManagement.label.BillingCycle": "Ciclo de facturación",
    "billManagement.label.BDOM": "BDOM",
    "billManagement.label.LastBillingDate": "Último día de facturación",
    "billManagement.label.NextBillingDate": "Próximo día de facturación",
    "billManagement.label.InterfaceDay": "Día de interfaz",
    "billManagement.label.CurrentCycleDate": "Día actual del ciclo",
    "billManagement.label.NoOfProfileBills": "Número de facturas",
    "billManagement.label.Status": "Estado",
    "billManagement.label.History": "Historial",
    "billManagement.label.Action": "Acción",
    "billManagement.label.BillHistory": "Historial de facturación",
    "billManagement.label.TrialBillHistory": "Historial de facturas de prueba",
    "billManagement.label.ExecutionDate": "Fecha de ejecución",
    "billManagement.label.ExpectedNoOfCustomer": "Número esperado de clientes",
    "billManagement.label.ActualBilledCustomer":
      "Número real de clientes facturados",
    "billManagement.label.TotalBillingAmount": "Monto total de facturación",
    "billManagement.label.DownloadReport": "Descargar informe",
    "billManagement.label.DownloadBillDetail": "Descargar detalle de factura",
    "billManagement.label.BillCycleName": "Nombre del ciclo de facturación",
    "billManagement.label.BillFrequency": "Frecuencia de facturación",
    "billManagement.label.BillingDayOfMonth": "Día de facturación del mes",
    "billManagement.label.Cancel": "Cancelar",
    "billManagement.label.Confirm": "Confirmar",

    "billManagement.label.BillingCycleName": "Nombre del ciclo de facturación",
  "billManagement.label.BillingFrequency": "Frecuencia de facturación",
    "billManagement.label.ChargeJobRunId": "ID de ejecución de trabajo de cobro",
  },

  pt: {
    "billManagement.label.BillCycle": "Ciclo de cobrança",
    "billManagement.label.billing": "Faturamento",
    "billManagement.label.trialBilling": "Faturamento de teste",
    "billManagement.label.start": "Iniciar",
    "billManagement.label.all": "Todos",
    "billManagement.label.upload": "Carregar",
    "billManagement.label.BillingManagement": "Gestão de faturamento",
    "billManagement.label.CreateBillingCycle": "Gerar faturamento",
    "billManagement.label.BillingDay": "Dia de faturamento",
    "billManagement.label.BillingCycle": "Ciclo de faturamento",
    "billManagement.label.BDOM": "BDOM",
    "billManagement.label.LastBillingDate": "Último dia de faturamento",
    "billManagement.label.NextBillingDate": "Próximo dia de faturamento",
    "billManagement.label.InterfaceDay": "Dia de interface",
    "billManagement.label.CurrentCycleDate": "Dia atual do ciclo",
    "billManagement.label.NoOfProfileBills": "Número de faturas",
    "billManagement.label.Status": "Status",
    "billManagement.label.History": "Histórico",
    "billManagement.label.Action": "Ação",
    "billManagement.label.BillHistory": "Histórico de faturamento",
    "billManagement.label.TrialBillHistory": "Histórico de faturas de teste",
    "billManagement.label.ExecutionDate": "Data de execução",
    "billManagement.label.ExpectedNoOfCustomer": "Número esperado de clientes",
    "billManagement.label.ActualBilledCustomer":
      "Número real de clientes faturados",
    "billManagement.label.TotalBillingAmount": "Valor total do faturamento",
    "billManagement.label.DownloadReport": "Baixar relatório",
    "billManagement.label.DownloadBillDetail": "Baixar detalhes da fatura",
    "billManagement.label.BillCycleName": "Nome do ciclo de faturamento",
    "billManagement.label.BillFrequency": "Frequência de faturamento",
    "billManagement.label.BillingDayOfMonth": "Dia de faturamento do mês",
    "billManagement.label.Cancel": "Cancelar",
    "billManagement.label.Confirm": "Confirmar",

    "billManagement.label.BillingCycleName": "Nome do ciclo de faturamento",
  "billManagement.label.BillingFrequency": "Frequência de faturamento",
    "billManagement.label.ChargeJobRunId": "ID de execução do trabalho de cobrança",
  },

  zh_CN: {
    "billManagement.label.BillCycle": "账单周期",
    "billManagement.label.billing": "账单",
    "billManagement.label.trialBilling": "试算账单",
    "billManagement.label.start": "开始",
    "billManagement.label.all": "全部",
    "billManagement.label.upload": "上传",
    "billManagement.label.BillingManagement": "账单管理",
    "billManagement.label.CreateBillingCycle": "生成账单",
    "billManagement.label.BillingDay": "账单日",
    "billManagement.label.BillingCycle": "账单周期",
    "billManagement.label.BDOM": "账单日",
    "billManagement.label.LastBillingDate": "上次账单日",
    "billManagement.label.NextBillingDate": "下次账单日",
    "billManagement.label.InterfaceDay": "接口日",
    "billManagement.label.CurrentCycleDate": "当前周期日",
    "billManagement.label.NoOfProfileBills": "账单数量",
    "billManagement.label.Status": "状态",
    "billManagement.label.History": "历史记录",
    "billManagement.label.Action": "操作",
    "billManagement.label.BillHistory": "账单历史",
    "billManagement.label.TrialBillHistory": "试算账单历史",
    "billManagement.label.ExecutionDate": "执行日期",
    "billManagement.label.ExpectedNoOfCustomer": "预计客户数量",
    "billManagement.label.ActualBilledCustomer": "实际账单客户数",
    "billManagement.label.TotalBillingAmount": "账单总金额",
    "billManagement.label.DownloadReport": "下载报告",
    "billManagement.label.DownloadBillDetail": "下载账单详情",
    "billManagement.label.BillCycleName": "账单周期名称",
    "billManagement.label.BillFrequency": "账单频率",
    "billManagement.label.BillingDayOfMonth": "每月账单日",
    "billManagement.label.Cancel": "取消",
    "billManagement.label.Confirm": "确认",

    "billManagement.label.BillingCycleName": "账单周期名称",
    "billManagement.label.BillingFrequency": "账单频率",
    "billManagement.label.ChargeJobRunId": "收费作业运行ID",
  },

  hi: {
    "billManagement.label.BillCycle": "बिल चक्र",
    "billManagement.label.billing": "बिलिंग",
    "billManagement.label.trialBilling": "परीक्षण बिलिंग",
    "billManagement.label.start": "प्रारंभ",
    "billManagement.label.all": "सभी",
    "billManagement.label.upload": "अपलोड",
    "billManagement.label.BillingManagement": "बिल प्रबंधन",
    "billManagement.label.CreateBillingCycle": "बिल जनरेट करें",
    "billManagement.label.BillingDay": "बिल दिवस",
    "billManagement.label.BillingCycle": "बिल चक्र",
    "billManagement.label.BDOM": "बिल दिवस (BDOM)",
    "billManagement.label.LastBillingDate": "अंतिम बिल दिवस",
    "billManagement.label.NextBillingDate": "अगला बिल दिवस",
    "billManagement.label.InterfaceDay": "इंटरफेस दिवस",
    "billManagement.label.CurrentCycleDate": "वर्तमान चक्र दिवस",
    "billManagement.label.NoOfProfileBills": "बिलों की संख्या",
    "billManagement.label.Status": "स्थिति",
    "billManagement.label.History": "इतिहास",
    "billManagement.label.Action": "क्रिया",
    "billManagement.label.BillHistory": "बिल इतिहास",
    "billManagement.label.TrialBillHistory": "परीक्षण बिल इतिहास",
    "billManagement.label.ExecutionDate": "निष्पादन तिथि",
    "billManagement.label.ExpectedNoOfCustomer": "अपेक्षित ग्राहकों की संख्या",
    "billManagement.label.ActualBilledCustomer": "वास्तविक बिल किए गए ग्राहक",
    "billManagement.label.TotalBillingAmount": "कुल बिल राशि",
    "billManagement.label.DownloadReport": "रिपोर्ट डाउनलोड करें",
    "billManagement.label.DownloadBillDetail": "बिल विवरण डाउनलोड करें",
    "billManagement.label.BillCycleName": "बिल चक्र का नाम",
    "billManagement.label.BillFrequency": "बिल की आवृत्ति",
    "billManagement.label.BillingDayOfMonth": "महीने का बिल दिवस",
    "billManagement.label.Cancel": "रद्द करें",
    "billManagement.label.Confirm": "पुष्टि करें",

    "billManagement.label.BillingCycleName": "बिलिंग चक्र का नाम",
    "billManagement.label.BillingFrequency": "बिलिंग की आवृत्ति",
    "billManagement.label.ChargeJobRunId": "चार्ज जॉब रन आईडी",
  },

  ka: {
    "billManagement.label.BillCycle": "ბილინგის ციკლი",
    "billManagement.label.billing": "ბილინგი",
    "billManagement.label.trialBilling": "საცდელი ბილინგი",
    "billManagement.label.start": "დაწყება",
    "billManagement.label.all": "ყველა",
    "billManagement.label.upload": "ატვირთვა",
    "billManagement.label.BillingManagement": "ბილინგის მართვა",
    "billManagement.label.CreateBillingCycle": "ბილინგის გენერაცია",
    "billManagement.label.BillingDay": "ბილინგის დღე",
    "billManagement.label.BillingCycle": "ბილინგის ციკლი",
    "billManagement.label.BDOM": "BDOM",
    "billManagement.label.LastBillingDate": "ბოლო ბილინგის დღე",
    "billManagement.label.NextBillingDate": "შემდეგი ბილინგის დღე",
    "billManagement.label.InterfaceDay": "ინტერფეისის დღე",
    "billManagement.label.CurrentCycleDate": "მიმდინარე ციკლის დღე",
    "billManagement.label.NoOfProfileBills": "ბილინგების რაოდენობა",
    "billManagement.label.Status": "სტატუსი",
    "billManagement.label.History": "ისტორია",
    "billManagement.label.Action": "მოქმედება",
    "billManagement.label.BillHistory": "ბილინგის ისტორია",
    "billManagement.label.TrialBillHistory": "საცდელი ბილინგის ისტორია",
    "billManagement.label.ExecutionDate": "შესრულების თარიღი",
    "billManagement.label.ExpectedNoOfCustomer":
      "მოსალოდნელი მომხმარებელთა რაოდენობა",
    "billManagement.label.ActualBilledCustomer":
      "ფაქტობრივად ბილინგირებული მომხმარებელი",
    "billManagement.label.TotalBillingAmount": "ბილინგის მთლიანი თანხა",
    "billManagement.label.DownloadReport": "ანგარიშის ჩამოტვირთვა",
    "billManagement.label.DownloadBillDetail": "ბილინგის დეტალების ჩამოტვირთვა",
    "billManagement.label.BillCycleName": "ბილინგის ციკლის სახელი",
    "billManagement.label.BillFrequency": "ბილინგის სიხშირე",
    "billManagement.label.BillingDayOfMonth": "თვის ბილინგის დღე",
    "billManagement.label.Cancel": "გაუქმება",
    "billManagement.label.Confirm": "დადასტურება",

     "billManagement.label.BillingCycleName": "ბილინგის ციკლის სახელი",
    "billManagement.label.BillingFrequency": "ბილინგის სიხშირე",
    "billManagement.label.ChargeJobRunId": "ჩარიცხვის სამუშაოს ID",
  },

  lo: {
    "billManagement.label.BillCycle": "ວົງຈອນໃບບິນ",
    "billManagement.label.billing": "ໃບບິນ",
    "billManagement.label.trialBilling": "ໃບບິນທົດລອງ",
    "billManagement.label.start": "ເລີ່ມຕົ້ນ",
    "billManagement.label.all": "ທັງໝົດ",
    "billManagement.label.upload": "ອັບໂຫລດ",
    "billManagement.label.BillingManagement": "ການຄຸ້ມຄອງໃບບິນ",
    "billManagement.label.CreateBillingCycle": "ສ້າງໃບບິນ",
    "billManagement.label.BillingDay": "ວັນທີໃບບິນ",
    "billManagement.label.BillingCycle": "ວົງຈອນໃບບິນ",
    "billManagement.label.BDOM": "BDOM",
    "billManagement.label.LastBillingDate": "ວັນທີໃບບິນທ່ອນຜ່ານມາ",
    "billManagement.label.NextBillingDate": "ວັນທີໃບບິນຖັດໄປ",
    "billManagement.label.InterfaceDay": "ວັນທີອິນເຕີເຟດ",
    "billManagement.label.CurrentCycleDate": "ມື້ປະຈຸບັນໃນວົງຈອນ",
    "billManagement.label.NoOfProfileBills": "ຈໍານວນໃບບິນ",
    "billManagement.label.Status": "ສະຖານະ",
    "billManagement.label.History": "ປະຫວັດ",
    "billManagement.label.Action": "ການປະຕິບັດ",
    "billManagement.label.BillHistory": "ປະຫວັດໃບບິນ",
    "billManagement.label.TrialBillHistory": "ປະຫວັດໃບບິນທົດລອງ",
    "billManagement.label.ExecutionDate": "ວັນທີດຳເນີນການ",
    "billManagement.label.ExpectedNoOfCustomer": "ຈໍານວນລູກຄ້າທີ່ຄາດຫວັງ",
    "billManagement.label.ActualBilledCustomer":
      "ຈໍານວນລູກຄ້າທີ່ຖືກຄິດໃບບິນຈິງ",
    "billManagement.label.TotalBillingAmount": "ຈຳນວນເງິນລວມຂອງໃບບິນ",
    "billManagement.label.DownloadReport": "ດາວໂຫລດບົດລາຍງານ",
    "billManagement.label.DownloadBillDetail": "ດາວໂຫລດລາຍລະອຽດໃບບິນ",
    "billManagement.label.BillCycleName": "ຊື່ວົງຈອນໃບບິນ",
    "billManagement.label.BillFrequency": "ຄວາມຖີ່ໃບບິນ",
    "billManagement.label.BillingDayOfMonth": "ວັນທີໃບບິນຂອງເດືອນ",
    "billManagement.label.Cancel": "ຍົກເລີກ",
    "billManagement.label.Confirm": "ຢືນຢັນ",

    "billManagement.label.BillingCycleName": "ຊື່ວົງຈອນການເກັບເງິນ",
  "billManagement.label.BillingFrequency": "ຄວາມຖີ່ໃນການເກັບເງິນ",
    "billManagement.label.ChargeJobRunId": "ລະຫັດງານຮັບເງິນ",
  },

  my_MM: {
    "billManagement.label.BillCycle": "ဘေလ်ဆိုင်ကယ်",
    "billManagement.label.billing": "ဘီလ်",
    "billManagement.label.trialBilling": "စမ်းသပ်ဘီလ်",
    "billManagement.label.start": "စတင်ပါ",
    "billManagement.label.all": "အားလုံး",
    "billManagement.label.upload": "တင်ပါ",
    "billManagement.label.BillingManagement": "ဘီလ်စီမံခန့်ခွဲမှု",
    "billManagement.label.CreateBillingCycle": "ဘီလ်ထုတ်ယူမှု",
    "billManagement.label.BillingDay": "ဘီလ်နေ့",
    "billManagement.label.BillingCycle": "ဘီလ်စက်ဝန်း",
    "billManagement.label.BDOM": "BDOM",
    "billManagement.label.LastBillingDate": "နောက်ဆုံးဘီလ်နေ့",
    "billManagement.label.NextBillingDate": "နောက်ဘီလ်နေ့",
    "billManagement.label.InterfaceDay": "အင်တာဖေ့စ်နေ့",
    "billManagement.label.CurrentCycleDate": "လက်ရှိစက်ဝန်းနေ့",
    "billManagement.label.NoOfProfileBills": "ဘီလ်အရေအတွက်",
    "billManagement.label.Status": "အခြေအနေ",
    "billManagement.label.History": "မှတ်တမ်း",
    "billManagement.label.Action": "လုပ်ဆောင်မှု",
    "billManagement.label.BillHistory": "ဘီလ်မှတ်တမ်း",
    "billManagement.label.TrialBillHistory": "စမ်းသပ်ဘီလ်မှတ်တမ်း",
    "billManagement.label.ExecutionDate": "ဆောင်ရွက်သည့်နေ့",
    "billManagement.label.ExpectedNoOfCustomer": "ခန့်မှန်းဖောက်သည်အရေအတွက်",
    "billManagement.label.ActualBilledCustomer": "တကယ်ဘီလ်ထုတ်ထားသောဖောက်သည်",
    "billManagement.label.TotalBillingAmount": "စုစုပေါင်းဘီလ်ငွေပမာဏ",
    "billManagement.label.DownloadReport": "အစီရင်ခံစာဒေါင်းလုပ်ရန်",
    "billManagement.label.DownloadBillDetail": "ဘီလ်အသေးစိတ်ဒေါင်းလုပ်ရန်",
    "billManagement.label.BillCycleName": "ဘီလ်စက်ဝန်းအမည်",
    "billManagement.label.BillFrequency": "ဘီလ်ထုတ်ယူမှုကြိမ်နှုန်း",
    "billManagement.label.BillingDayOfMonth": "လစဉ်ဘီလ်ထုတ်ယူမည့်နေ့",
    "billManagement.label.Cancel": "ဖျက်သိမ်းမည်",
    "billManagement.label.Confirm": "အတည်ပြုမည်",

    "billManagement.label.BillingCycleName": "ဘီလ်ပေးသွင်းမှုအကြိမ်အနွယ်အမည်",
  "billManagement.label.BillingFrequency": "ဘီလ်ထုတ်သည့်ကြိမ်နှုန်း",
    "billManagement.label.ChargeJobRunId": "ဘီလ်ထုတ်လုပ်မှုအလုပ် ID",
  },

  my: {
    "billManagement.label.BillCycle": "ဘေလ်ဆိုင်ကယ်",
    "billManagement.label.billing": "ဘီလ်",
    "billManagement.label.trialBilling": "စမ်းသပ်ဘီလ်",
    "billManagement.label.start": "စတင်ပါ",
    "billManagement.label.all": "အားလုံး",
    "billManagement.label.upload": "တင်ပါ",
    "billManagement.label.BillingManagement": "ဘီလ်စီမံခန့်ခွဲမှု",
    "billManagement.label.CreateBillingCycle": "ဘီလ်ထုတ်ရန်",
    "billManagement.label.BillingDay": "ဘီလ်ထုတ်သည့်နေ့",
    "billManagement.label.BillingCycle": "ဘီလ်စက်ဝန်း",
    "billManagement.label.BDOM": "BDOM",
    "billManagement.label.LastBillingDate": "နောက်ဆုံးဘီလ်နေ့",
    "billManagement.label.NextBillingDate": "နောက်ထပ်ဘီလ်နေ့",
    "billManagement.label.InterfaceDay": "အင်တာဖေ့စ်နေ့",
    "billManagement.label.CurrentCycleDate": "လက်ရှိစက်ဝန်းနေ့",
    "billManagement.label.NoOfProfileBills": "ဘီလ်အရေအတွက်",
    "billManagement.label.Status": "အခြေအနေ",
    "billManagement.label.History": "မှတ်တမ်း",
    "billManagement.label.Action": "လုပ်ဆောင်မှု",
    "billManagement.label.BillHistory": "ဘီလ်မှတ်တမ်း",
    "billManagement.label.TrialBillHistory": "စမ်းသပ်ဘီလ်မှတ်တမ်း",
    "billManagement.label.ExecutionDate": "ဆောင်ရွက်သည့်နေ့",
    "billManagement.label.ExpectedNoOfCustomer": "ခန့်မှန်းဖောက်သည်အရေအတွက်",
    "billManagement.label.ActualBilledCustomer": "တကယ်ဘီလ်ထုတ်ထားသောဖောက်သည်",
    "billManagement.label.TotalBillingAmount": "စုစုပေါင်းဘီလ်ပမာဏ",
    "billManagement.label.DownloadReport": "အစီရင်ခံစာဒေါင်းလုပ်ရန်",
    "billManagement.label.DownloadBillDetail": "ဘီလ်အသေးစိတ်ဒေါင်းလုပ်ရန်",
    "billManagement.label.BillCycleName": "ဘီလ်စက်ဝန်းအမည်",
    "billManagement.label.BillFrequency": "ဘီလ်ထုတ်ကြိမ်နှုန်း",
    "billManagement.label.BillingDayOfMonth": "လစဉ်ဘီလ်ထုတ်မည့်နေ့",
    "billManagement.label.Cancel": "မလုပ်တော့ပါ",
    "billManagement.label.Confirm": "အတည်ပြုပါ",

    "billManagement.label.BillingCycleName": "ဘီလ်ပေးသွင်းမှုအကြိမ်အနွယ်အမည်",
  "billManagement.label.BillingFrequency": "ဘီလ်ထုတ်သည့်ကြိမ်နှုန်း",
    "billManagement.label.ChargeJobRunId": "ဘီလ်ထုတ်လုပ်မှုအလုပ် ID",
  },

  vi: {
    "billManagement.label.BillCycle": "Chu kỳ thanh toán",
    "billManagement.label.billing": "Hóa đơn",
    "billManagement.label.trialBilling": "Hóa đơn thử nghiệm",
    "billManagement.label.start": "Bắt đầu",
    "billManagement.label.all": "Tất cả",
    "billManagement.label.upload": "Tải lên",
    "billManagement.label.BillingManagement": "Quản lý hóa đơn",
    "billManagement.label.CreateBillingCycle": "Tạo hóa đơn",
    "billManagement.label.BillingDay": "Ngày lập hóa đơn",
    "billManagement.label.BillingCycle": "Chu kỳ hóa đơn",
    "billManagement.label.BDOM": "Ngày lập hóa đơn",
    "billManagement.label.LastBillingDate": "Ngày lập hóa đơn gần nhất",
    "billManagement.label.NextBillingDate": "Ngày lập hóa đơn tiếp theo",
    "billManagement.label.InterfaceDay": "Ngày giao dịch",
    "billManagement.label.CurrentCycleDate": "Ngày trong chu kỳ hiện tại",
    "billManagement.label.NoOfProfileBills": "Số lượng hóa đơn",
    "billManagement.label.Status": "Trạng thái",
    "billManagement.label.History": "Lịch sử",
    "billManagement.label.Action": "Hành động",
    "billManagement.label.BillHistory": "Lịch sử hóa đơn",
    "billManagement.label.TrialBillHistory": "Lịch sử hóa đơn thử nghiệm",
    "billManagement.label.ExecutionDate": "Ngày thực hiện",
    "billManagement.label.ExpectedNoOfCustomer": "Số khách hàng dự kiến",
    "billManagement.label.ActualBilledCustomer": "Số khách hàng đã lập hóa đơn",
    "billManagement.label.TotalBillingAmount": "Tổng số tiền hóa đơn",
    "billManagement.label.DownloadReport": "Tải báo cáo",
    "billManagement.label.DownloadBillDetail": "Tải chi tiết hóa đơn",
    "billManagement.label.BillCycleName": "Tên chu kỳ hóa đơn",
    "billManagement.label.BillFrequency": "Tần suất lập hóa đơn",
    "billManagement.label.BillingDayOfMonth": "Ngày lập hóa đơn hàng tháng",
    "billManagement.label.Cancel": "Hủy bỏ",
    "billManagement.label.Confirm": "Xác nhận",

    "billManagement.label.BillingCycleName": "Tên chu kỳ thanh toán",
  "billManagement.label.BillingFrequency": "Tần suất thanh toán",

    "billManagement.label.ChargeJobRunId": "ID chạy công việc thu phí",
  },
};
